import React, { useEffect, useState } from "react";
import { Star, StarFull, StarHalf } from "./StarRate";
import _ from "lodash";
import shortid from "shortid";
import { STAR_DISPLAY_MAX, normalizeScoreToStars } from "../config/rating";

type Props = {
  value?: number;
  size?: number;
};

export default function StarRateNewTrustScore({ value = 0, size = 24 }: Props) {
  const max = STAR_DISPLAY_MAX;
  const [count, setCount] = useState<number>(normalizeScoreToStars(value));
  const updateCount = (newCount: number) => {
    setCount((prev) => (prev !== newCount ? newCount : prev));
  };

  useEffect(() => {
    updateCount(normalizeScoreToStars(value));
  }, [value]);

  const starRateColor = (rate = 1) => {
    if (rate <= 0) return "#000000";
    if (rate <= 1.49) return "#FF6060";
    if (rate <= 2.49) return "#FF9B45";
    if (rate <= 3.49) return "#FFD050";
    if (rate <= 4.49) return "#5596FF";
    return "#4060FF";
  };

  const renderStars = (renderValue: number) => (
    <div className="d-flex gap-x-1 select-none">
      {_.times(max, (i) => {
        const diff = renderValue - i;
        if (diff >= 1) {
          return (
            <StarFull
              key={shortid.generate()}
              size={size}
              color={starRateColor(renderValue)}
            />
          );
        } else if (diff >= 0.5) {
          return (
            <StarHalf
              key={shortid.generate()}
              size={size}
              color={starRateColor(renderValue)}
            />
          );
        } else {
          return <Star key={shortid.generate()} size={size} />;
        }
      })}
    </div>
  );

  return (
    <div
      className="d-flex gap-x-1 cursor-pointer"
      style={{ width: "fit-content" }}
      //   onPointerMove={onPointerMove}
      //   onPointerLeave={onPointerLeave}
      //   onPointerUp={onPointerUp}
    >
      {renderStars(count>=1 ? count : 0)}
    </div>
  );
}
